import { React } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../store/slices/modal/modalSlice";
import Logo from "../../partials/components/logo";
import pkg from "../../../../package.json";

import "../../../styles/aboutModal.css";

// El contraste del bundle compilado deja el texto del body en #8a92a6 sobre
// superficie blanca (3.11:1, falla WCAG AA). Aca se pisa con los dos tokens que
// el design system ya tiene: #0c112e (18.50:1) y #6c757d (4.69:1). El fix global
// de $body-color en dark.scss es otro issue, no va aca.
const Tick = () => (
  <svg
    className="about-tick"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const PLATFORMS = ["AWS", "Azure", "GCP", "Snowflake"];

const AboutModal = () => {
  const dispatch = useDispatch();

  // La fecha la resuelve el Dockerfile en el mismo RUN que compila (ver stage 1).
  // Fuera de Docker no existe, y el modal lo dice en vez de inventar una.
  const buildDate = process.env.REACT_APP_BUILD_DATE;
  const buildLabel = buildDate ? `build ${buildDate}` : "build unknown";

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <Modal.Header closeButton className="about-hero">
        <span className="about-hero-mark">
          <Logo color={false} />
        </span>
        <span className="about-hero-text">
          <Modal.Title as="h4" className="about-hero-name">
            Cloud Costing
          </Modal.Title>
          <span className="about-hero-version">{pkg.version}</span>
        </span>
      </Modal.Header>

      <Modal.Body className="about-body">
        <p className="about-lede">Your cloud cost command center.</p>

        <ul className="about-list">
          <li>
            <Tick />
            <span>Track and analyze spend across every platform in one place.</span>
          </li>
          <li>
            <Tick />
            <span>Get recommendations to cut what you&rsquo;re overpaying for.</span>
          </li>
          <li>
            <Tick />
            <span>Forecast next period before it reaches the invoice.</span>
          </li>
        </ul>

        <div className="about-platforms">
          <span className="about-platforms-label">Works with</span>
          <span className="about-chips">
            {PLATFORMS.map((platform) => (
              <span className="about-chip" key={platform}>
                {platform}
              </span>
            ))}
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer className="about-footer">
        <span className="about-meta">
          {buildLabel} &middot;{" "}
          <a
            className="about-help"
            href="https://cloudcostingdocs.seidoranalytics.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClose}
          >
            Help center
          </a>
        </span>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
};

export default AboutModal;
